const cache = (() => ({
  data: [],
  index: {},
}))();

export const data = cache.data;
export const index = cache.index;

export default cache;
